<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="isScreenAccessible else screenNotAccessible" style="overflow: auto;">
    <app-documents-panel-list 
    [showLoader] = "showLoader"
    [documentSearchResult]="documentSearchResult" 
    [isShowCheckbox]="true" 
    (checkboxSelection)="includeInactive($event)" 
    [enableInactiveLabel]=" true"
    [checkboxLabel]="showAllLabel" 
    [showInformationIconCheckbox]="true" 
    [informationIconTooltip]="inactiveTooltip">
</app-documents-panel-list>
</div>
<ng-template #screenNotAccessible>
    <app-error [errorMessage]="errorMessage"></app-error>
  </ng-template>

